import { useMutation, UseMutationOptions } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { assetStorageApi } from 'src/Services/API';
import { FileInfoDto } from 'src/Services/API/generated';

export const useFetchStorageItemInformation = (
  options?: UseMutationOptions<FileInfoDto, unknown, string>
) => {
  const assetId = useCurrentAssetId();

  return useMutation<FileInfoDto, unknown, string>(
    ['get-public-url', assetId],
    async fileId => {
      if (!assetId) {
        throw new Error('No asset selected');
      }
      const response = await assetStorageApi.assetStorageControllerFindOne(assetId, fileId);
      return response.data;
    },
    options
  );
};
